import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import type { Event } from 'lumen/models';

interface GeneralEventNameSignature {
  Args: {
    event: Partial<Pick<Event, 'isCancelled' | 'isUnconfirmed' | 'name'>>;
    strikethrough?: boolean;
  };
  Element: HTMLSpanElement;
}

const GeneralEventName = <template>
  <span class="flex min-w-0 items-center gap-100" ...attributes>
    <span
      class="truncate {{if @strikethrough 'cancelled-event'}}"
      data-test-id="event-name"
      title={{@event.name}}
    >
      {{@event.name}}
    </span>
    {{#if (or @event.isCancelled @event.isUnconfirmed)}}
      <span class="shrink-0" data-test-id="event-name-tags">
        {{#if @event.isCancelled}}({{t "general.cancelled"}}){{/if}}
        {{#if @event.isUnconfirmed}}({{t "general.unconfirmed"}}){{/if}}
      </span>
    {{/if}}
  </span>
</template> satisfies TOC<GeneralEventNameSignature>;

export default GeneralEventName;
